<template>
    <div>
        <b-modal id="ModalConfirmNotHasTestModal" centered title="Xác nhận không có bài thi" hide-footer
            :no-close-on-backdrop="true" hide-header-close>
            <p class="">Khi học viên không có bài thi, hệ thống sẽ tự động chấm bài <span style="color: red">0
                    điểm</span></p>
            <p style="font-weight: bold">Bạn có chắc chắn muốn tiếp tục?</p>
            <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-secondary mr-4" @click="cancelModal()">Hủy bỏ</button>
                <button type="button" class="btn btn-info" @click="submit()"><i class="el-icon-loading"
                        v-if="loading"></i> Xác nhận</button>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ConfirmNotHasTestModal",
    data() {
        return {
            loading: false
        }
    },
    methods: {
        cancelModal() {
            this.$bvModal.hide("ModalConfirmNotHasTestModal")
            this.$emit('cancel-not-have-test')
        },
        submit() {
            this.$emit('markZeroPoint')
            this.$bvModal.hide("ModalConfirmNotHasTestModal");
        }
    }
}
</script>
<style></style>